module.exports = __webpack_public_path__ + "static/media/Group2.f67fc37e.webp";